import { useEffect, useState } from 'react';
import { ButtonField, Modal, ModalHeader, ModalBody, ModalFooter, ButtonGroup, ButtonGroupItem, Iconsvg, InputField } from '@wk/components-react16';
import { API_USER } from '../../config/constants';
import HttpService from "../../config/http.service";
import { Toast } from '../../services';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';

const Profile = ({ data }: any) => {
    const { isOpenProfile, setIsOpenProfile } = data;
    const { authUser } = useSelector((state: RootState) => state.auth);
    interface UserProfile {
        id?: number;
        name?: string;
        roles?: string;
        designation?: string;
        userId?: number;
        email?: string;
    }

    const [userProfile, setUserProfile] = useState<UserProfile>({});
    const [editUserProfile, setEditUserProfile] = useState<UserProfile>({} as UserProfile);
    const [isEditProfile, setIsEditProfile] = useState(false as boolean);

    const editProfile = (profile: any) => {
        setIsEditProfile(true);
        setEditUserProfile({
            id: profile.id,
            name: profile.name ? profile.name : '',
            roles: profile.roles ? profile.roles : '',
            designation: profile.designation ?  profile.designation : '',
            userId: profile.userInfo.id,
        });
    }

    const viewProfile = () => {
        setIsEditProfile(false);
        setEditUserProfile({});
    }

    const handleUserRequest = (origin: string) => {
        if (origin === 'esc' || origin === 'header' || origin === 'footer') {
            setIsOpenProfile(false);
            setEditUserProfile({});
        }
    }

    const handleInputChange = (event: any) => {
        const { name, value } = event.target;
        setEditUserProfile({
            ...editUserProfile,
            [name]: value,
        });
    };

    const isValidInput = (profile: any) => {
        if (!profile.name || !profile.name.trim()) {
            Toast('Please enter user name', "error");
            return false;
        }
        if (!profile.designation || !profile.designation.trim()) {
            Toast('Please enter user designation', "error");
            return false;
        }
        if (!profile.roles || !profile.roles.trim()) {
            Toast('Please enter user role & responsibilities', "error");
            return false;
        }
        return true;
    }

    const handleUpdateProfile = () => {
        if (!isValidInput(editUserProfile)) return;
        HttpService.postRequest(API_USER.USER_PROFILE_UPDATE, editUserProfile).then(
            (res: any) => {
                Toast('User Profile updated successfully.', "success");
                const obj = { ...res, email: authUser?.username }
                setUserProfile(obj);
                setIsEditProfile(false);
            },
            (err: any) => {
                Toast(err.message, "error");
            }
        )
    }

    const getUserProfile = () => {
        HttpService.getRequest(`${API_USER.USER_PROFILE_GET}`).then((res: any) => {
            const obj = { ...res, email: authUser?.username}
            setUserProfile(obj);
        }, (err: any) => {
            Toast(err.message, "error");
        })
    }

    useEffect(() => {
        getUserProfile();
    }, []);

    return (
        <div className='custom-wizard'>
            <Modal
                isOpen={isOpenProfile}
                srLabelledBy={'modal-id-profile'}
                srDescribedBy={'modal-id-profile'}
                width={'750px'} onUserRequest={handleUserRequest}>
                <ModalHeader
                    titleId={'modal-id-profile'}
                    isFullscreenButtonVisible={false}
                    onUserRequest={() => handleUserRequest('header')}>
                    Profile
                </ModalHeader>
                <ModalBody descriptionId="modal-id-profile">
                    {isEditProfile ? <div className='wk-grid-page-container p-0'>
                        <div className="wk-grid mt-20">
                            <div className="wk-column-12 ">
                                <InputField label="Name" labelFor="input-id-1-1" indicator="required">
                                    <input
                                        type="text" id="input-id-1-1" name="name"
                                        placeholder="Name"
                                        onChange={(event: any) => handleInputChange(event)}
                                        value={editUserProfile.name} autoComplete="off"
                                    />
                                </InputField>
                                <InputField label="Designation" labelFor="input-id-1-2" indicator="required">
                                    <input
                                        type="text" id="input-id-1-2" name="designation"
                                        placeholder="Designation"
                                        onChange={(event: any) => handleInputChange(event)}
                                        value={editUserProfile.designation} autoComplete="off"
                                    />
                                </InputField>
                                <InputField label="Role & Responsibilities" labelFor="input-id-1-3" indicator="required">
                                    <input
                                        type="text" id="input-id-1-3" name="roles"
                                        placeholder="Role & Responsibilities"
                                        onChange={(event: any) => handleInputChange(event)}
                                        value={editUserProfile.roles} autoComplete="off"
                                    />
                                </InputField>
                            </div>
                        </div>
                    </div> : <div className='wk-grid-page-container p-0'>
                            <div className="d-flex pt-10">
                                <div className="card-title2 wk-size-6 pr-30" style={{ color: '#85BC20' }}>
                                    {userProfile?.name}
                                    <div className="wk-text-muted wk-size-2" style={{ color: '#353535' }}>{userProfile?.designation}</div>
                                    <div className="mt-5 wk-size-2 wk-text-muted-light"><Iconsvg name="mail"></Iconsvg> {" "} {userProfile?.email}</div>
                                </div>
                                <div className="ms-auto">
                                    <div className="wk-avatar wk-avatar-extreme-large">
                                        <div className="wk-fishbowl-thumbs wk-fishbowl-thumbs-default">
                                            <div
                                                className="wk-fishbowl-user-thumb wk-fishbowl-user-thumb-default"
                                            >
                                                <span className="wk-sr-only"></span>
                                                <span className="wk-icon-filled-user"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="wk-grid mt-20 mb-20">
                                <div className="wk-column-12">
                                    <div className="card-title2">
                                        Role & Responsibilities
                                    </div>
                                    <div className="wk-size-2">{userProfile?.roles}</div>
                                </div>
                            </div>
                        </div>
                    }
                </ModalBody>
                <ModalFooter>
                    <ButtonGroup mode="static">
                        <ButtonGroupItem slot="buttonGroupItem">
                            <ButtonField mode={'ghost'}>
                                <button
                                    className='mr-10'
                                    type="button"
                                    id="cancel"
                                    onClick={()=>handleUserRequest('footer')}>
                                    Close
                                </button>
                                {isEditProfile ? (
                                    <button
                                        className='mr-10'
                                        type="button"
                                        id="edit"
                                        onClick={() => viewProfile()}>
                                        View
                                    </button>
                                ) : null}
                            </ButtonField>
                            <ButtonField mode={'ghost'}>
                                {!isEditProfile ? (
                                    <button
                                        className='mr-10'
                                        type="button"
                                        id="edit"
                                        onClick={() => editProfile(userProfile)}>
                                        Edit
                                    </button>
                                ) : (
                                    <button
                                        className='mr-10'
                                        type="button"
                                        id="update"
                                        onClick={handleUpdateProfile}>
                                        Update
                                    </button>
                                )}
                            </ButtonField>
                        </ButtonGroupItem>
                    </ButtonGroup>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default Profile;
